import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL
//=====================Terminal Type URL=========================
export const Partner_GetList = `${BASE_API_URL}/Partner/Partner_GetList`
export const Partner_AddDetails = `${BASE_API_URL}/Partner/Partner_AddDetails`
export const Partner_UpdateDetails = `${BASE_API_URL}/Partner/Partner_UpdateDetails`
export const Partner_GetBy_PartnerID = `${BASE_API_URL}/Partner/Partner_GetBy_PartnerID`
export const Partner_Delete_Details = `${BASE_API_URL}/Partner/Partner_Delete_Details`
export const Partner_Updates_Isactive = `${BASE_API_URL}/Partner/Partner_Updates_Isactive`
export const Partner_Updates_IsPayOnline = `${BASE_API_URL}/Partner/Partner_Updates_IsPayOnline`
export const Partner_Updates_IsSubscription = `${BASE_API_URL}/Partner/Partner_Updates_IsSubscription`
export const GetPartnerDetailsByPartnerID = `${BASE_API_URL}/Partner/GetPartnerDetailsByPartnerID`
export const PARTNER_PASSWORD_RESET = `${BASE_API_URL}/Partner/PartnerChangPwd_ByAdmin`

export function GetAllPartner_GetListAPI() {
  return axios.get(Partner_GetList)
}

export function AddPartner_AddDetailsAPI(
  packageID: number,
  stateID: number,
  cityID: number,
  areaPincodeID: number,
  partnerName: string,
  contactPerson: string,
  contactNumber: string,
  emailID: string,
  address: string,
  latitude: string,
  longitude: string,
  razorpayKey: string,
  razorpaySecretKey: string,
  photoPath: string,
  isSubscription: boolean,
  isPayOnline: boolean,
  isActive: boolean,
  isMinOrderAmount: boolean,
  minOrderAmount: number,
  isDeliveryCharge: boolean,
  deliveryCharge: number,
  freeDeliveryOnAmount: number,
  createBy: number,
  ipAddress: string
) {
  return axios.post(Partner_AddDetails, {
    packageID,
    stateID,
    cityID,
    areaPincodeID,
    partnerName,
    contactPerson,
    contactNumber,
    emailID,
    address,
    latitude,
    longitude,
    razorpayKey,
    razorpaySecretKey,
    photoPath,
    isSubscription,
    isPayOnline,
    isActive, isMinOrderAmount,
    minOrderAmount,
    isDeliveryCharge,
    deliveryCharge,
    freeDeliveryOnAmount,
    createBy,
    ipAddress,
  })
}
export function UpdatePartner_UpdateDetailsAPI(
  partnerID: number,
  packageID: number,
  stateID: number,
  cityID: number,
  areaPincodeID: number,
  partnerName: string,
  contactPerson: string,
  contactNumber: string,
  emailID: string,
  address: string,
  latitude: string,
  longitude: string,
  razorpayKey: string,
  razorpaySecretKey: string,
  photoPath: string,
  isSubscription: boolean,
  isPayOnline: boolean,
  isActive: boolean,isMinOrderAmount: boolean,
  minOrderAmount: number,
  isDeliveryCharge: boolean,
  deliveryCharge: number,
  freeDeliveryOnAmount: number,
  updateBy: number,
  ipAddress: string
) {
  return axios.post(Partner_UpdateDetails, {
    partnerID,
    packageID,
    stateID,
    cityID,
    areaPincodeID,
    partnerName,
    contactPerson,
    contactNumber,
    emailID,
    address,
    latitude,
    longitude,
    razorpayKey,
    razorpaySecretKey,
    photoPath,
    isSubscription,
    isPayOnline,
    isActive, isMinOrderAmount,
    minOrderAmount,
    isDeliveryCharge,
    deliveryCharge,
    freeDeliveryOnAmount,
    updateBy,
    ipAddress,
  })
}

export function GetPartner_GetBy_PartnerIDAPI(partnerID: number) {
  return axios.post(Partner_GetBy_PartnerID, {partnerID})
}
export function IsPartner_Updates_IsactiveAPI(partnerID: number, isActive: boolean) {
  return axios.post(Partner_Updates_Isactive, {partnerID, isActive})
}
export function IsPartner_Updates_IsPayOnlineAPI(partnerID: number, isPayOnline: boolean) {
  return axios.post(Partner_Updates_IsPayOnline, {partnerID, isPayOnline})
}

export function IsPartner_Updates_IsSubscriptionAPI(partnerID: number, isSubscription: boolean) {
  return axios.post(Partner_Updates_IsSubscription, {partnerID, isSubscription})
}

export function deletePartner_Delete_DetailsAPI(partnerID: number) {
  return axios.post(Partner_Delete_Details, {partnerID})
}

export function GetPartner_DetailsByPartnerIDAPI(partnerID: number) {
  return axios.post(GetPartnerDetailsByPartnerID, {partnerID})
}
export function PartnerPasswordReset(partnerID: number, newPwd: string) {
  return axios.post(PARTNER_PASSWORD_RESET, {partnerID, newPwd})
}
